<template>
  <div></div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    resultName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('document', ['fileObj']),
    ...mapState('system', ['routerStatusRedirect']),
  },
  methods: {
    ...mapActions('document', ['getDocuments']),
  },
  async created() {
    console.log(`status check ${this.resultName}`)
    if (!this.fileObj) {
      await this.getDocuments()
    }
    const { businessLicense } = this.fileObj
    if (!businessLicense) {
      const path = '/signup/documents'
      if (this.$route.path !== path && this.routerStatusRedirect) {
        return await this.$router.replace(path)
      }
      return
    }

    this.$emit('emitNext', {
      name: this.resultName,
      result: true,
    })
  },
}
</script>
